import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { KION_ERROR_PAGE_TYPE } from "../../../util/interfaces"
import { KionButton } from "../../button/button"
import s from './styles.module.scss'

interface ErrorScheme {
	title: string,
	msg?: string,
	btnName: string
	action: () => void
}

export function KionError() {
	const routerPush = useNavigate()

	function moveTo(link: string) {
		window.location.assign(link)
	}

	const errorsMap: Map<KION_ERROR_PAGE_TYPE, ErrorScheme> = new Map([
		[KION_ERROR_PAGE_TYPE.LIMIT_REACHED,
		{
			title: 'Превышено число устройств',
			msg: `К учетной записи МТС ТВ можно подключить не более 5 устройств. Удалите устройство и попробуйте снова`,
			btnName: 'Перейти в настройки',
			action: () => routerPush('/')
		}
		],
		[KION_ERROR_PAGE_TYPE.IMPOSSIBLE_TO_CONNECT,
		{
			title: 'Подключение невозможно',
			msg: `У Вас уже подключен пакет «Онлайн-кинотеатры». Для <br> подключения пакета «Развлекательное» необходимо отключить пакет <br> «Онлайн-кинотеатры». Совместное использование этих пакетов невозможно`,
			btnName: 'Перейти в настройки',
			action: () => routerPush('/')
		}
		],
		[KION_ERROR_PAGE_TYPE.UNKNOWN_OPERATOR,
		{
			title: 'Неподдерживаемый оператор сотовой связи',
			msg: `Номер телефона принадлежит оператору сотовой связи, который не поддерживается в соответствии с условиями участия в акции. Введите другой номер телефона или приобретите SIM-карту оператора МТС`,
			btnName: 'Показать карту салонов МТС',
			action: () => window.location.href = 'https://moskva.mts.ru/personal/podderzhka/zoni-obsluzhivaniya/offices/'
		}
		],
		[KION_ERROR_PAGE_TYPE.ACCOUNT_NOT_FOUND,
		{
			title: 'Телефон не зарегестрирован',
			msg: `Для начала необходимо зарегестрироваться в системе`,
			btnName: 'Зарегестрироваться',
			action: () => window.location.href = 'https://mtstv.mts.ru/home'
		}],
		[KION_ERROR_PAGE_TYPE.PROMO_OUTDATED, {
			title: `Промокод устарел`,
			btnName: 'Ввести другой промокод',
			action: () => routerPush('/')
		}],
		[KION_ERROR_PAGE_TYPE.BALANCE_NOT_ENOUGH, {
			title: `На вашем счете недостаточно средств`,
			btnName: 'Назад',
			action: () => routerPush('/')
		}]
	])

	const [error, setError] = useState<ErrorScheme>({
		title: '',
		msg: `
        Неизестная ошибка. Что-то пошло не так. <br>
        Попробуйте вернуться позже или попробовать снова
    `,
		btnName: 'Назад',
		action: () => routerPush('/')
	})

	const location = useLocation();
	useEffect(() => {
		window.sessionStorage.removeItem("request_id")
		const errMsg = window.sessionStorage.getItem('errMsg');

		if (errMsg) {
			setError({
				title: '',
				msg: errMsg,
				btnName: 'Назад',
				action: () => routerPush('/')
			});
		}

		const queryType = new URLSearchParams(location.search).get('type')
		if (queryType && typeof queryType === 'string') {
			setError(errorsMap.get(queryType as KION_ERROR_PAGE_TYPE) || error)
		}
	}, [])

	return (
		<div style={{
			background: '#090B3F',
			height: '100vh',
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
		}}>
			<div className={s['err-wrapper']}>
				<div className={s.icon}>
					<img src="/images/error-icon.svg" />
				</div>
				{error.title}
				<span
					className={s['err-msg']}
					dangerouslySetInnerHTML={{ __html: error.msg! }}
				/>

				<div className={s['btn-block']}>
					<KionButton onClick={() => moveTo('https://kion.ru')}>
						Перейти на kion.ru
					</KionButton>
					<KionButton onClick={error.action}>
						{error.btnName}
					</KionButton>
				</div>

				<div className={s['app-ref-row']}>
					<img src="/images/appstores//google-play.svg"
						onClick={() => moveTo('https://play.google.com/store/apps/details?id=ru.mts.mtstv')} />
					<img src="/images/appstores//app-store.svg"
						onClick={() => moveTo('https://apps.apple.com/ru/app/id1451612172')} />
					<img src="/images/appstores//app-gallery.svg"
						onClick={() => moveTo('https://appgallery.huawei.com/#/app/C101183499')} />
				</div>
			</div>
		</div>
	)
}
